{
    "APP_NAME": "AESC Visitor Registration",

    "new": "New",
    "draft": "Draft",
    "submitted": "Submitted",
    "hrApproved": "Approved by HR",
    "ehsApproved": "Approved by EHS",
    "inReview": "In Review",
    "approved": "Approved",
    "approvedForReview": "Approved for review",
    "hrApprovedForReview": "HR Approved for review",
    "ehsApprovedForReview": "EHS Approved for review",
    "rejected": "Rejected",
    "archived": "Archived",

    "male": "Male",
    "female": "Female",

    "businessTrip": "Business Trip",
    "workOnSite": "Work On Site",

    "europeanPassport": "European Passport",
    "otherPassport": "Other Passport, no need for business visa",
    "businessVisa": "Business Visa",
    "otherEuBusinessVisa": "Other EU Country Business Visa",
    "otherEuCountryWorkVisa": "Other EU Country Working Visa",

    "WorkVisit": "Work Visit",
    "shortTermAssignment": "Short Term Assignment",

    "ict": "ICT",
    "mobilityIct": "Mobility ICT",
    "spVisa": "SP Visa"
}